export const LANGUAGES = [
  { code: "pt-PT", label: "Português", flag: "PT" },
  { code: "es-ES", label: "Español", flag: "ES" },
  { code: "en-US", label: "English", flag: "EN" },
];

const pt = {
  brand_subtitle: "Rotina Organizada",
  brand_message: "Conte hidratos. Organize a rotina. Viva com mais confiança.",
  demo_banner: "Modo demonstração — dados fictícios e isolados (utilizadora Sunny).",
  demo_short: "Demonstração",
  loading: "A carregar…",
  save: "Guardar",
  cancel: "Cancelar",
  remove: "Remover",
  close: "Fechar",
  confirm: "Confirmar",
  optional: "opcional",
  not_available: "Não disponível",
  back: "Voltar",

  // auth
  login: "Entrar",
  logout: "Terminar sessão",
  register: "Criar conta",
  create_access: "Cadastrar acesso",
  email: "E-mail",
  password: "Palavra-passe",
  name: "Nome",
  login_title: "Bem-vindo de volta",
  login_sub: "Entre para continuar a organizar a rotina.",
  register_title: "Criar a sua conta",
  register_sub: "Comece a organizar o acompanhamento em poucos passos.",
  no_account: "Ainda não tem conta?",
  have_account: "Já tem conta?",
  forgot_password: "Esqueceu-se da palavra-passe?",
  forgot_title: "Recuperar acesso",
  forgot_sub: "Enviaremos um link para repor a palavra-passe.",
  reset_title: "Definir nova palavra-passe",
  send_link: "Enviar link",
  reset_done: "Palavra-passe atualizada. Já pode entrar.",
  verify_title: "Confirmar e-mail",
  verify_pending: "A confirmar…",
  verify_ok: "E-mail confirmado com sucesso.",
  verify_fail: "Não foi possível confirmar o e-mail.",
  email_not_connected: "Envio de e-mail ainda não ligado. Use o link abaixo para confirmar:",
  resend: "Reenviar confirmação",
  verify_banner: "Confirme o seu e-mail para proteger a conta.",

  // nav
  nav_home: "Início",
  nav_meals: "Refeições",
  nav_glucose: "Glicemia",
  nav_analysis: "Análise",
  nav_doses: "Dose Insulina Diária",
  nav_history: "Histórico",
  nav_record: "Ficha Completa",
  nav_family: "Família",
  nav_settings: "Definições",
  nav_more: "Mais",
  monitoring: "A acompanhar",
  register_action: "Registar",

  // register sheet
  register_q: "O que pretende registar?",
  reg_glucose: "Glicemia",
  reg_glucose_sub: "Valor manual em mg/dL ou mmol/L",
  reg_meal: "Refeição",
  reg_meal_sub: "Contagem de hidratos de carbono",
  reg_dose: "Dose aplicada",
  reg_dose_sub: "Insulina efetivamente aplicada",

  // onboarding
  onb_title: "Vamos organizar o acompanhamento",
  onb_who: "Quem será acompanhado?",
  onb_self: "Eu próprio(a)",
  onb_child: "Uma criança (gerida por si)",
  onb_other: "Outro adulto",
  onb_name: "Nome preferido",
  onb_unit: "Unidade de glicemia",
  onb_features: "O que pretende usar?",
  onb_consents: "Consentimentos",
  onb_consent_data: "Autorizo o tratamento dos meus dados para funcionamento da aplicação.",
  onb_consent_demo: "Compreendo que esta é uma versão em desenvolvimento.",
  onb_country: "País",
  onb_finish: "Concluir",
  onb_birth: "Data de nascimento",
  feat_meals: "Contar hidratos / refeições",
  feat_glucose: "Registar glicemia",
  feat_insulin: "Registar insulina",
  feat_family: "Partilhar com a família",

  // dashboard
  hi: "Olá",
  dash_sub: "Tudo o que importa, num só lugar.",
  last_glucose: "Última glicemia",
  no_reading: "Sem leitura registada",
  carbs_today: "Hidratos hoje",
  meals_count: "refeições",
  insulin_today: "Insulina hoje",
  applied_registered: "aplicada e registada",
  target_range: "Intervalo-alvo",
  grams: "g",
  units: "U",
  ago_min: "há {n} min",
  ago_hour: "há {n} h",
  manual_note: "Introduzido manualmente — não sincronizado com o sensor.",
  glucose_today: "Glicemia de hoje",
  recent_meals: "Refeições recentes",
  see_all: "Ver todas",
  shared_routine: "Acompanhamento familiar",
  caregivers: "pessoas com acesso",
  quick_register: "Registo rápido",
  no_meals_today: "Ainda sem refeições registadas hoje.",
  not_confirmed_zero: "Ausência de registos não é zero confirmado.",

  // status
  st_in: "No alvo",
  st_above: "Elevada",
  st_below: "Baixa (atento)",

  // meals
  meals_title: "Refeições",
  meals_sub: "Conte hidratos e organize as refeições habituais.",
  add_meal: "Adicionar refeição",
  meal_mode_photo: "Calcular por foto",
  meal_mode_100: "Calcular por 100 g",
  meal_mode_direct: "Digitar hidratos diretamente",
  meal_food: "Alimento / nome da refeição",
  meal_hc100: "Hidratos por 100 g de alimento (g)",
  meal_weight: "Peso que vai consumir (g)",
  meal_direct: "Total de hidratos que vai consumir (g)",
  meal_formula: "Fórmula",
  meal_total: "Total de hidratos",
  meal_datetime: "Data e hora da refeição",
  meal_notes: "Observações",
  meal_add_item: "Adicionar outro alimento",
  meal_review: "Rever antes de guardar",
  meal_method_used: "Método usado",
  photo_not_ready: "IA ainda não ligada neste protótipo.",
  photo_take: "Tirar foto da refeição",
  photo_gallery: "Escolher fotografia da galeria",
  photo_demo: "Ver exemplo (fictício)",
  photo_demo_note: "Exemplo fictício e independente da fotografia. Não é um reconhecimento real.",
  photo_single: "Alimento avulso",
  photo_plate: "Prato pronto",
  photo_single_hint: "Um só alimento: a IA reconhece-o e mostra os hidratos por 100 g. Indique o peso para calcular.",
  photo_plate_hint: "Prato completo: a IA reconhece todos os alimentos e estima os hidratos de cada um.",
  photo_remove: "Remover imagem",
  ai_on: "IA ligada — estimativa de hidratos por fotografia.",
  ai_analyze: "Analisar fotografia (IA)",
  ai_analyzing: "A analisar fotografia…",
  ai_done: "Estimativa concluída. Reveja e corrija os alimentos e porções antes de guardar.",
  ai_badge: "Estimativa IA",
  ai_note: "Estimativa por IA a partir da foto — reveja e corrija. Hidratos são o resultado principal. Valores desconhecidos aparecem como «Não disponível».",
  extras: "Extras nutricionais",
  meal_saved: "Refeição guardada.",
  meal_invalid: "Verifique os valores introduzidos.",
  no_meals: "Sem refeições registadas.",

  // glucose
  glucose_title: "Glicemia",
  glucose_sub: "Leituras organizadas, com origem e horário.",
  new_reading: "Nova leitura",
  g_value: "Valor da glicemia",
  g_unit: "Unidade",
  g_datetime: "Data e hora da leitura",
  g_source: "Origem",
  src_sensor: "Sensor",
  src_capillary: "Medição capilar",
  g_relation: "Relação com refeição",
  g_notes: "Observações",
  g_saved: "Leitura guardada.",
  g_table_dt: "Data / hora",
  g_table_value: "Glicemia",
  g_table_source: "Origem",
  g_table_author: "Autor",
  no_glucose: "Sem leituras registadas.",

  // doses
  doses_title: "Dose Insulina Diária",
  doses_sub: "Aplicações registadas e relação descritiva com o peso.",
  register_dose: "Registar aplicação",
  d_insulin: "Insulina",
  d_units: "Dose efetivamente aplicada (U)",
  d_datetime: "Data e hora da aplicação",
  d_purpose: "Finalidade",
  purp_basal: "Basal",
  purp_meal: "Refeição / correção",
  purp_unspec: "Não informada",
  d_notes: "Observações",
  total_today: "Total hoje",
  subtotal_basal: "Basal",
  subtotal_meal: "Refeição / correção",
  subtotal_unspec: "Não informada",
  applications: "aplicações",
  u_per_kg: "U/kg/dia",
  weight_used: "Peso utilizado",
  weight_date: "Data da pesagem",
  no_weight: "Sem peso válido — indicador não calculado.",
  descriptive_note: "Indicador descritivo. Não classifica a dose nem recomenda alterações.",
  day_not_zero: "Dia sem registos não significa zero insulina.",
  confirm_complete: "Confirmar registo do dia como completo",
  record_confirmed: "Registo confirmado pelo utilizador.",
  d_saved: "Aplicação guardada.",
  edit: "Editar",
  actions: "Ações",
  corrected: "Corrigido",
  correction_history: "Histórico de correções",
  no_corrections: "Sem correções.",
  record_updated: "Registo atualizado (correção guardada no histórico).",
  profiles_title: "Perfis acompanhados",
  add_profile_btn: "Adicionar perfil",
  edit_profile: "Editar perfil",
  new_profile: "Novo perfil",
  relationship: "Relação",
  profile_saved: "Perfil guardado.",
  switch_to: "Mudar para",
  remove_profile: "Remover perfil",
  account_title: "O meu perfil (conta)",
  account_sub: "Os seus dados de acesso à aplicação.",
  change_photo: "Alterar foto",
  access_title: "Acessos e permissões",
  access_sub: "Quem tem acesso a este perfil e o que pode fazer.",
  your_permissions: "As suas permissões",
  no_doses: "Sem aplicações registadas.",
  not_sum_suggestions: "Totais não incluem sugestões, simulações ou rascunhos.",

  // analysis
  analysis_title: "Análise",
  analysis_sub: "Um olhar sobre os registos, com contexto.",
  filter_day: "Dia",
  filter_7: "7 dias",
  filter_14: "14 dias",
  filter_30: "30 dias",
  readings: "Leituras",
  average: "Média das leituras",
  pct_in_target: "Percentagem de leituras registadas dentro do alvo",
  below: "Abaixo",
  within: "Dentro",
  above: "Acima",
  not_tir: "Esta métrica não é «Tempo no alvo». Não estima HbA1c nem GMI.",
  tir_sensor: "Tempo no alvo · Sensor",
  tir_unavailable: "Tempo no alvo indisponível. Requer integração/importação de sensor validada.",
  an_target: "Intervalo do alvo",
  an_no_target: "Sem alvo definido",
  an_days_with: "{n} dia(s) com leituras",
  an_minmax: "Mínimo / Máximo",
  an_per_day: "Média por dia",
  an_readings_day: "leituras por dia",
  an_readings: "leitura(s)",
  an_period_title: "Glicemia ao longo do período",
  an_period_sub: "Cada ponto é uma leitura registada. A faixa azul é o intervalo do alvo.",
  an_hourly_title: "Perfil por hora do dia",
  an_hourly_sub: "Média (linha) e mínimo–máximo (barras) das leituras em cada hora.",
  an_bands_title: "Distribuição por faixas",
  an_bands_sub: "Percentagem das leituras registadas em cada faixa.",
  an_daily_title: "Hidratos e insulina por dia",
  an_daily_sub: "Total de hidratos registados (g) e unidades de insulina aplicadas (U).",

  // history
  history_title: "Histórico",
  history_sub: "Cada registo no seu momento.",
  h_all: "Todos",

  // record
  record_title: "Ficha Completa",
  record_sub: "Informações reunidas para acompanhar com mais clareza.",
  sec_identification: "Identificação",
  sec_measures: "Medidas",
  sec_health: "Saúde",
  sec_allergies: "Alergias e intolerâncias",
  sec_meds: "Medicações e dispositivos",
  sec_prescription: "Prescrição",
  sec_contacts: "Contactos",
  birth_date: "Data de nascimento",
  age: "Idade",
  years: "anos",
  weight: "Peso (kg)",
  height: "Altura (cm)",
  diabetes_type: "Tipo de diabetes",
  diagnosis_year: "Ano do diagnóstico",
  no_diagnosis: "Não gera diagnósticos nem classificações.",
  allergy_state_none: "Nenhuma conhecida confirmada",
  allergy_state_unknown: "Não informado",

  // family
  family_title: "Família",
  family_sub: "Acompanhamento partilhado, com acessos claros.",
  who_accompanies: "Quem está a acompanhar",
  intended_permissions: "Permissões por perfil",
  monitoring_space: "Espaço de acompanhamento",
  who_follows: "Quem acompanha {name}",
  planned_perms: "Permissões previstas",
  access_full: "Acesso completo",
  access_log: "Pode registar",
  access_read: "Apenas leitura",
  add_responsavel: "Adicionar responsável",
  edit_responsavel: "Editar responsável",
  new_responsavel: "Novo responsável",
  resp_limit: "Limite de {max} responsáveis atingido.",
  resp_login_hint: "Vai poder iniciar sessão com este e-mail e a mesma palavra-passe que a sua.",
  resp_added: "Responsável adicionado.",
  resp_updated: "Responsável atualizado.",
  resp_removed: "Responsável removido.",
  photo_label: "Foto de perfil",
  mydata_title: "Meus Dados",
  mydata_sub: "Os seus dados de conta. Edite o nome, o e-mail e a foto de perfil.",
  pg_history: "Consultar histórico e análise",
  pg_logs: "Registar refeições e glicemia",
  pg_doses: "Registar doses aplicadas",
  pg_correct: "Corrigir registos",
  pg_record: "Consultar ficha completa",
  pg_prescription: "Gerir prescrição",
  pg_caregivers: "Gerir acessos e cuidadores",
  pg_export: "Exportar dados",
  simulate_invite: "Simular convite",
  invite_email: "E-mail do convidado",
  invite_role: "Papel",
  invite_send: "Criar convite (simulado)",
  invite_created: "Convite simulado criado (não é enviado e-mail real).",
  role_responsavel: "Responsável",
  role_adulto: "Pessoa acompanhada",
  role_cuidador: "Cuidador",
  invites: "Convites",
  revoke: "Revogar",
  pending: "Pendente",
  revoked: "Revogado",
  caregiver_note: "Um cuidador autorizado a registar refeições não recebe automaticamente acesso a todos os dados de saúde.",
  perm_view_history: "Consultar histórico",
  perm_view_analysis: "Consultar análise",
  perm_log_meals: "Registar refeições",
  perm_log_glucose: "Registar glicemia",
  perm_log_doses: "Registar doses",
  perm_correct_records: "Corrigir registos",
  perm_view_full_record: "Consultar ficha completa",
  perm_log_measures: "Registar peso e altura",
  perm_manage_prescription: "Gerir prescrição",
  perm_manage_caregivers: "Gerir cuidadores",
  perm_export_data: "Exportar dados",

  // settings
  settings_title: "Definições",
  settings_sub: "Alvos, prescrição e preferências por perfil.",
  set_target: "Intervalo-alvo de glicemia",
  set_target_sub: "Usado nos gráficos. Padrão inicial editável, não um ideal universal.",
  lower_limit: "Limite inferior",
  upper_limit: "Limite superior",
  set_prescription: "Parâmetros de prescrição",
  fsi: "FSI (mg/dL por 1 U)",
  ratio_ihc: "Rácio I/HC (1 U para ___ g)",
  correction_target: "Alvo de correção",
  prescription_confirm: "Confirmo que estes dados correspondem à minha prescrição atual.",
  prescription_confirmed: "Prescrição confirmada pelo utilizador.",
  not_clinical_validation: "Não é uma validação clínica do software.",
  set_recommendation: "Recomendação de insulina",
  use_recommendation: "Utilizar recomendação de insulina",
  engine_not_configured: "Motor clínico não configurado.",
  recommendation_note: "A ativação da preferência não liberta recomendações sem especificação clínica validada.",
  language: "Idioma",
  target_saved: "Intervalo-alvo guardado.",
  prescription_saved: "Prescrição guardada.",
};

const es = {
  brand_subtitle: "Rutina Organizada",
  brand_message: "Cuenta hidratos. Organiza la rutina. Vive con más confianza.",
  demo_banner: "Modo demostración — datos ficticios y aislados (usuaria Sunny).",
  demo_short: "Demostración",
  loading: "Cargando…", save: "Guardar", cancel: "Cancelar", remove: "Eliminar",
  close: "Cerrar", confirm: "Confirmar", optional: "opcional", not_available: "No disponible", back: "Volver",
  login: "Entrar", logout: "Cerrar sesión", register: "Crear cuenta", email: "Correo",
  password: "Contraseña", name: "Nombre",
  login_title: "Bienvenido de nuevo", login_sub: "Entra para seguir organizando la rutina.",
  register_title: "Crea tu cuenta", register_sub: "Empieza a organizar el seguimiento en unos pasos.",
  no_account: "¿Aún no tienes cuenta?", have_account: "¿Ya tienes cuenta?",
  forgot_password: "¿Olvidaste la contraseña?", forgot_title: "Recuperar acceso",
  forgot_sub: "Enviaremos un enlace para restablecer la contraseña.",
  reset_title: "Nueva contraseña", send_link: "Enviar enlace",
  reset_done: "Contraseña actualizada. Ya puedes entrar.",
  verify_title: "Confirmar correo", verify_pending: "Confirmando…",
  verify_ok: "Correo confirmado.", verify_fail: "No se pudo confirmar el correo.",
  email_not_connected: "Envío de correo aún no conectado. Usa el enlace para confirmar:",
  resend: "Reenviar confirmación", verify_banner: "Confirma tu correo para proteger la cuenta.",
  nav_home: "Inicio", nav_meals: "Comidas", nav_glucose: "Glucemia", nav_analysis: "Análisis",
  nav_doses: "Dosis Insulina Diaria", nav_history: "Historial", nav_record: "Ficha Completa",
  nav_family: "Familia", nav_settings: "Ajustes", nav_more: "Más",
  monitoring: "Acompañando", register_action: "Registrar",
  register_q: "¿Qué quieres registrar?", reg_glucose: "Glucemia",
  reg_glucose_sub: "Valor manual en mg/dL o mmol/L", reg_meal: "Comida",
  reg_meal_sub: "Conteo de hidratos de carbono", reg_dose: "Dosis aplicada",
  reg_dose_sub: "Insulina realmente aplicada",
  hi: "Hola", dash_sub: "Todo lo que importa, en un solo lugar.",
  last_glucose: "Última glucemia", no_reading: "Sin lectura registrada",
  carbs_today: "Hidratos hoy", meals_count: "comidas", insulin_today: "Insulina hoy",
  target_range: "Rango objetivo", grams: "g", units: "U",
  st_in: "En objetivo", st_above: "Elevada", st_below: "Baja (atento)",
  meals_title: "Comidas", add_meal: "Añadir comida", meal_mode_photo: "Calcular por foto",
  meal_mode_100: "Calcular por 100 g", meal_mode_direct: "Escribir hidratos directamente",
  glucose_title: "Glucemia", doses_title: "Dosis Insulina Diaria",
  analysis_title: "Análisis", history_title: "Historial", record_title: "Ficha Completa",
  family_title: "Familia", settings_title: "Ajustes", language: "Idioma",
};

const en = {
  brand_subtitle: "Organized Routine",
  brand_message: "Count carbs. Organize the routine. Live with more confidence.",
  demo_banner: "Demo mode — fictional, isolated data (user Sunny).",
  demo_short: "Demo",
  loading: "Loading…", save: "Save", cancel: "Cancel", remove: "Remove",
  close: "Close", confirm: "Confirm", optional: "optional", not_available: "Not available", back: "Back",
  login: "Sign in", logout: "Sign out", register: "Create account", email: "Email",
  password: "Password", name: "Name",
  login_title: "Welcome back", login_sub: "Sign in to keep organizing the routine.",
  register_title: "Create your account", register_sub: "Start organizing monitoring in a few steps.",
  no_account: "No account yet?", have_account: "Already have an account?",
  forgot_password: "Forgot password?", forgot_title: "Recover access",
  forgot_sub: "We'll send a link to reset your password.",
  reset_title: "Set new password", send_link: "Send link",
  reset_done: "Password updated. You can sign in now.",
  verify_title: "Confirm email", verify_pending: "Confirming…",
  verify_ok: "Email confirmed.", verify_fail: "Could not confirm email.",
  email_not_connected: "Email delivery not connected yet. Use the link to confirm:",
  resend: "Resend confirmation", verify_banner: "Confirm your email to secure your account.",
  nav_home: "Home", nav_meals: "Meals", nav_glucose: "Glucose", nav_analysis: "Analysis",
  nav_doses: "Daily Insulin Dose", nav_history: "History", nav_record: "Health Record",
  nav_family: "Family", nav_settings: "Settings", nav_more: "More",
  monitoring: "Monitoring", register_action: "Register",
  register_q: "What would you like to register?", reg_glucose: "Glucose",
  reg_glucose_sub: "Manual value in mg/dL or mmol/L", reg_meal: "Meal",
  reg_meal_sub: "Carbohydrate counting", reg_dose: "Applied dose",
  reg_dose_sub: "Insulin actually applied",
  hi: "Hi", dash_sub: "Everything that matters, in one place.",
  last_glucose: "Last glucose", no_reading: "No reading recorded",
  carbs_today: "Carbs today", meals_count: "meals", insulin_today: "Insulin today",
  target_range: "Target range", grams: "g", units: "U",
  st_in: "In target", st_above: "High", st_below: "Low (watch)",
  meals_title: "Meals", add_meal: "Add meal", meal_mode_photo: "Calculate by photo",
  meal_mode_100: "Calculate per 100 g", meal_mode_direct: "Type carbs directly",
  glucose_title: "Glucose", doses_title: "Daily Insulin Dose",
  analysis_title: "Analysis", history_title: "History", record_title: "Health Record",
  family_title: "Family", settings_title: "Settings", language: "Language",
};

export const dictionaries = { "pt-PT": pt, "es-ES": es, "en-US": en };
